import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import React from 'react';

const COVInspectionFields = ({ findings, setFindings }) => {
   const handleInputChange = (field, value) => {
      setFindings(prev => ({
         ...prev,
         covFindings: {
            ...prev.covFindings || {},
            [field]: value
         }
      }));
   };

   const handleVolumeChange = (field, value) => {
      setFindings(prev => ({
         ...prev,
         covFindings: {
            ...prev.covFindings || {},
            volume: {
               ...(prev.covFindings?.volume || {}),
               [field]: parseFloat(value) || 0
            }
         }
      }));
   };

   const handleQuantityChange = (field, value) => {
      setFindings(prev => ({
         ...prev,
         covFindings: {
            ...prev.covFindings || {},
            quantity: {
               ...(prev.covFindings?.quantity || {}),
               [field]: field === 'value' ? (parseInt(value) || 0) : value
            }
         }
      }));
   };

   return (
      <div className="space-y-6">
         <div>
            <Label className="text-base font-semibold">Forest Products Information</Label>
            <Table>
               <TableHeader>
                  <TableRow>
                     <TableHead className="w-[150px]">Kind</TableHead>
                     <TableHead className="w-[150px]">Species</TableHead>
                     <TableHead className="w-[150px]">Scientific Name</TableHead>
                     <TableHead className="w-[120px]">No. of Trees</TableHead>
                     <TableHead className="w-[200px]">Quantity of Lumber</TableHead>
                     <TableHead>Volume</TableHead>
                  </TableRow>
               </TableHeader>
               <TableBody>
                  <TableRow>
                     <TableCell>
                        <Input
                           value={findings?.covFindings?.kind || ''}
                           onChange={(e) => handleInputChange('kind', e.target.value)}
                           placeholder="e.g., Lumbers"
                        />
                     </TableCell>
                     <TableCell>
                        <Input
                           value={findings?.covFindings?.species || ''}
                           onChange={(e) => handleInputChange('species', e.target.value)}
                           placeholder="e.g., Acacia"
                        />
                     </TableCell>
                     <TableCell>
                        <Input
                           value={findings?.covFindings?.scientificName || ''}
                           onChange={(e) => handleInputChange('scientificName', e.target.value)}
                           placeholder="e.g., Samanea saman"
                        />
                     </TableCell>
                     <TableCell>
                        <Input
                           type="number"
                           value={findings?.covFindings?.numberOfTrees || ''}
                           onChange={(e) => handleInputChange('numberOfTrees', parseInt(e.target.value) || 0)}
                           placeholder="e.g., 3"
                           min="1"
                        />
                     </TableCell>
                     <TableCell>
                        <div className="flex items-center space-x-2">
                           <Input
                              type="number"
                              value={findings?.covFindings?.quantity?.value || ''}
                              onChange={(e) => handleQuantityChange('value', e.target.value)}
                              placeholder="Quantity"
                              className="w-24"
                           />
                           <Input
                              value={findings?.covFindings?.quantity?.unit || ''}
                              onChange={(e) => handleQuantityChange('unit', e.target.value)}
                              placeholder="Unit"
                              className="w-24"
                           />
                        </div>
                     </TableCell>
                     <TableCell>
                        <div className="flex items-center space-x-2">
                           <div className="flex items-center">
                              <Input
                                 type="number"
                                 step="0.01"
                                 value={findings?.covFindings?.volume?.cubicMeters || ''}
                                 onChange={(e) => handleVolumeChange('cubicMeters', e.target.value)}
                                 placeholder="0.00"
                                 className="w-24"
                              />
                              <span className="ml-2 text-sm text-muted-foreground">cu.m</span>
                           </div>
                           <div className="flex items-center">
                              <Input
                                 type="number"
                                 step="0.01"
                                 value={findings?.covFindings?.volume?.boardFeet || ''}
                                 onChange={(e) => handleVolumeChange('boardFeet', e.target.value)}
                                 placeholder="0.00"
                                 className="w-24"
                              />
                              <span className="ml-2 text-sm text-muted-foreground">bd ft</span>
                           </div>
                        </div>
                     </TableCell>
                  </TableRow>
               </TableBody>
            </Table>
         </div>

         {/* Conveyance and Consignee Fields */}
         <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
               <Label>Conveyance</Label>
               <Input
                  value={findings?.covFindings?.conveyance || ''}
                  onChange={(e) => handleInputChange('conveyance', e.target.value)}
                  placeholder="e.g., Isuzu Forward Wing Van"
               />
            </div>

            <div className="space-y-2">
               <Label>Consignee</Label>
               <Input
                  value={findings?.covFindings?.consignee || ''}
                  onChange={(e) => handleInputChange('consignee', e.target.value)}
                  placeholder="Enter consignee"
               />
            </div>
         </div>
      </div>
   );
};

export default COVInspectionFields;